import { combineReducers } from 'redux'
import cities from './cities'
import vacancies from './vacancies'
import companies from './companies'
import vacancy from './vacancy'
import internship from './internship'
import internshipList from './internshipList'
import personal from './personal'
import worker from './worker'
import company from './company'
import employments from './employments'
import baseCity from './baseCity'
import banners from './banners'
import scope_activity from './scope_activity'
import experience from './experience'
import filter from './filter'
import map from './map'
import modal from './modal'
import about from './about'
import help from './help'
import information from './information'
import footer from './footer'
import social from './social'

export default combineReducers({
  vacancies,
  cities,
  companies,
  vacancy,
  internshipList,
  internship,
  personal,
  worker,
  company,
  employments,
  baseCity,
  banners,
  scope_activity,
  experience,
  filter,
  map,
  modal,
  about,
  help,
  information,
  footer,
  social
})



// WEBPACK FOOTER //
// ./src/reducers/index.js